/* POWER BRANDS - QR Code Generator: disegno e download (anteprima, cornici, PNG/SVG/PDF) + conversione anteprime del progetto.
   Le funzioni pure si provano in Node; le librerie (qr-code-styling, jsPDF, pdf.js, ag-psd) si caricano solo al primo uso. */
(function (root) {
  const D = {};
  const CDN = {
    qr: "https://cdn.jsdelivr.net/npm/qr-code-styling@1.9.2/lib/qr-code-styling.js",
    jspdf: "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js",
    pdfjs: "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.10.38/pdf.min.mjs",
    pdfWorker: "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.10.38/pdf.worker.min.mjs",
    psd: "https://cdn.jsdelivr.net/npm/ag-psd@30.2.0/dist/bundle.js",
  };
  const MAX_BYTE = 200 * 1024 * 1024, MAX_MPIXEL = 100e6, MAX_KB = 800 * 1024;
  const ERR_LIB = "Libreria per le anteprime non raggiungibile: controlla la connessione e riprova.";
  const ERR_ANTEPRIMA = "Non riesco a creare l'anteprima di questo file: carica uno screenshot o un'esportazione JPG/PDF.";
  const esc = (s) => String(s === null || s === undefined ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&apos;" }[c]));

  /* ---------- funzioni pure ---------- */
  D.misuraRidotta = function (w, h, max) {
    max = max || 1600;
    const lungo = Math.max(w, h);
    if (lungo <= max) return { w, h };
    const f = max / lungo;
    return { w: Math.max(1, Math.round(w * f)), h: Math.max(1, Math.round(h * f)) };
  };
  const estensione = (f) => { const m = /\.([a-z0-9]+)$/i.exec(String((f && f.name) || "")); return m ? m[1].toLowerCase() : ""; };
  D.tipoSorgente = function (file) {
    const e = estensione(file), t = String((file && file.type) || "").toLowerCase();
    if (e === "pdf" || e === "ai" || t === "application/pdf") return "pdf";
    if (e === "psd" || t === "image/vnd.adobe.photoshop") return "psd";
    if (t.startsWith("video/")) return "video";
    if (t.startsWith("image/") || ["heic", "heif", "tif", "tiff", "svg", "avif"].includes(e)) return "immagine";
    return "sconosciuto";
  };
  D.controllaIngresso = (file) => file && file.size > MAX_BYTE ? "Il file è troppo grande (massimo 200 MB)." : null;
  D.nomeFile = function (nome, ext) {
    const s = String(nome || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    return "qr-" + (s || "codice") + "." + ext;
  };

  /* Cornice: il QR resta com'è, annidato in un SVG più alto con fascia colorata + testo. */
  D.svgCornice = function (svg, stile) {
    const st = stile || {}, pos = st.cornice;
    svg = String(svg).replace(/^\s*<\?xml[^>]*\?>\s*/i, "");
    if (!pos || pos === "nessuna") return svg;
    const apri = /<svg\b[^>]*>/i.exec(svg), fine = svg.lastIndexOf("</svg>");
    if (!apri || fine < 0) return svg;
    const tag = apri[0], inner = svg.slice(apri.index + tag.length, fine);
    const vb = /viewBox="\s*[\d.-]+[\s,]+[\d.-]+[\s,]+([\d.]+)[\s,]+([\d.]+)\s*"/.exec(tag);
    const wa = /\swidth="([\d.]+)/.exec(tag);
    const S = wa ? parseFloat(wa[1]) : vb ? parseFloat(vb[1]) : 300;
    const vbs = vb ? `0 0 ${vb[1]} ${vb[2]}` : `0 0 ${S} ${S}`;
    const r = (n) => Math.round(n * 100) / 100;
    const fascia = r(S * 0.22), H = r(S + fascia), col = esc(st.coloreCornice || "#ee2229"), rx = r(S * 0.06);
    const qy = pos === "sopra" ? fascia : 0, by = pos === "sopra" ? 0 : S;
    let corpo = `<svg x="0" y="${qy}" width="${S}" height="${S}" viewBox="${vbs}">${inner}</svg>`;
    if (pos === "bolla") { const sw = r(S * 0.03); corpo += `<rect x="${r(sw / 2)}" y="${r(sw / 2)}" width="${r(S - sw)}" height="${r(S - sw)}" rx="${rx}" fill="none" stroke="${col}" stroke-width="${sw}"/>`; }
    corpo += `<rect x="0" y="${by}" width="${S}" height="${fascia}" rx="${rx}" fill="${col}"/>`
      + `<text x="${r(S / 2)}" y="${r(by + fascia / 2)}" fill="#ffffff" font-family="Inter, Arial, sans-serif" font-weight="700" font-size="${r(S * 0.09)}" text-anchor="middle" dominant-baseline="central">${esc(st.testoCornice)}</text>`;
    const ns = (tag.match(/\sxmlns:[a-z]+="[^"]*"/gi) || []).filter((a) => !/xmlns:xlink=/i.test(a)).join("");
    return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"${ns} width="${S}" height="${H}" viewBox="0 0 ${S} ${H}">${corpo}</svg>`;
  };

  /* ---------- caricamento librerie (solo browser) ---------- */
  const caricati = {};
  const carica = (u, msg) => caricati[u] || (caricati[u] = new Promise((ok, ko) => { const s = document.createElement("script"); s.src = u; s.async = true; s.onload = ok; s.onerror = () => { delete caricati[u]; ko(new Error(msg)); }; document.head.appendChild(s); }));
  D.libreria = () => carica(CDN.qr, "Libreria QR non raggiungibile").then(() => root.QRCodeStyling);

  /* ---------- disegno ---------- */
  const istanze = new WeakMap();
  const opzioni = (codice, stile, px) => root.PBQr.opzioniLibreria(stile, root.PBQr.testoDaCodificare(codice), px);
  /* L'istanza non sta nel DOM: se ne prende l'SVG, si compone la cornice e si mette nell'elemento (stessa immagine dei download). */
  D.anteprima = async function (el, codice, stile) {
    let r = istanze.get(el);
    if (!r) { r = { giro: 0, q: null, nodo: null }; istanze.set(el, r); }
    const giro = ++r.giro; /* un solo contatore per elemento: scrive solo l'ultima chiamata */
    const QRS = await D.libreria(), o = opzioni(codice, stile, 240);
    if (r.q && r.nodo && el.contains(r.nodo)) r.q.update(o); else { r.q = new QRS(o); r.nodo = null; }
    const q = r.q, testo = await (await q.getRawData("svg")).text();
    if (giro !== r.giro) return q;
    el.innerHTML = D.svgCornice(testo, stile);
    r.nodo = el.firstElementChild;
    if (r.nodo) { r.nodo.removeAttribute("width"); r.nodo.removeAttribute("height"); r.nodo.style.cssText = "max-width:100%;height:auto;display:block"; }
    return q;
  };
  D.svg = async function (codice, stile) {
    const QRS = await D.libreria();
    const blob = await new QRS(opzioni(codice, stile, 1024)).getRawData("svg");
    return D.svgCornice(await blob.text(), stile);
  };
  const dimensioniSvg = (s) => { const w = /<svg\b[^>]*\swidth="([\d.]+)/.exec(s), h = /<svg\b[^>]*\sheight="([\d.]+)/.exec(s); return { w: w ? parseFloat(w[1]) : 1, h: h ? parseFloat(h[1]) : 1 }; };
  const aBlob = (canvas, tipo, q) => new Promise((ok, ko) => canvas.toBlob((b) => b ? ok(b) : ko(new Error("Esportazione immagine non riuscita")), tipo, q));
  D.png = async function (codice, stile, px) {
    const s = await D.svg(codice, stile), d = dimensioniSvg(s), W = Math.round(px), H = Math.round(px * d.h / d.w);
    const url = URL.createObjectURL(new Blob([s], { type: "image/svg+xml" }));
    try {
      const img = await new Promise((ok, ko) => { const i = new Image(); i.onload = () => ok(i); i.onerror = () => ko(new Error("Immagine QR non creata")); i.src = url; });
      const c = document.createElement("canvas"); c.width = W; c.height = H;
      c.getContext("2d").drawImage(img, 0, 0, W, H);
      return await aBlob(c, "image/png");
    } finally { URL.revokeObjectURL(url); }
  };
  const dataUrl = (b) => new Promise((ok, ko) => { const r = new FileReader(); r.onload = () => ok(r.result); r.onerror = () => ko(r.error); r.readAsDataURL(b); });
  D.pdf = async function (codice, stile, opz) {
    opz = opz || {};
    await carica(CDN.jspdf, "Libreria PDF non raggiungibile");
    const s = await D.svg(codice, stile), d = dimensioniSvg(s), prop = d.h / d.w;
    const img = await dataUrl(await D.png(codice, stile, 2048));
    let doc;
    if (opz.formato === "misura") {
      const w = (Number(opz.cm) || 5) * 10, h = w * prop;
      doc = new root.jspdf.jsPDF({ unit: "mm", compress: true, format: [w, h], orientation: h > w ? "p" : "l" });
      doc.addImage(img, "PNG", 0, 0, w, h);
    } else {
      doc = new root.jspdf.jsPDF({ unit: "mm", compress: true, format: "a4", orientation: "p" });
      const w = 80, h = w * prop, x = (210 - w) / 2;
      doc.addImage(img, "PNG", x, 60, w, h);
      if (codice && codice.nome) { doc.setFontSize(9); doc.setTextColor("#666666"); doc.text(String(codice.nome), 105, 60 + h + 8, { align: "center" }); }
    }
    return doc.output("blob");
  };
  D.scarica = function (nome, blob) {
    const url = URL.createObjectURL(blob), a = document.createElement("a");
    a.href = url; a.download = nome; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 4000);
  };

  /* ---------- conversione anteprime del progetto (spec 5.1) ---------- */
  const bianco = (w, h) => { const c = document.createElement("canvas"); c.width = w; c.height = h; const x = c.getContext("2d"); x.fillStyle = "#ffffff"; x.fillRect(0, 0, w, h); return { c, x }; };
  /* webp 0.8 (Safari: jpeg), poi 0.7, poi lato lungo -20% fino a 3 volte, finché sta sotto 800 KB */
  async function esporta(sorgente, w, h) {
    let { w: cw, h: ch } = D.misuraRidotta(w, h), blob = null, tipo = "image/webp";
    for (let giro = 0; giro < 4; giro++) {
      if (giro > 0) { cw = Math.max(1, Math.round(cw * 0.8)); ch = Math.max(1, Math.round(ch * 0.8)); }
      const { c, x } = bianco(cw, ch);
      x.drawImage(sorgente, 0, 0, cw, ch);
      blob = await aBlob(c, tipo, 0.8);
      if (tipo === "image/webp" && blob.type !== "image/webp") { tipo = "image/jpeg"; blob = await aBlob(c, tipo, 0.8); }
      if (blob.size > MAX_KB) blob = await aBlob(c, tipo, 0.7);
      if (blob.size <= MAX_KB) return { blob, tipo, larghezza: cw, altezza: ch };
    }
    throw new Error("Anteprima troppo pesante anche dopo la riduzione: carica uno screenshot.");
  }
  const controllaMpx = (w, h) => { if (w * h > MAX_MPIXEL) throw new Error("Immagine troppo grande da elaborare (oltre 100 megapixel)."); };
  async function daImmagine(file) {
    let bmp = null;
    try { bmp = await createImageBitmap(file, { imageOrientation: "from-image" }); } catch (e) { bmp = null; }
    if (bmp) { controllaMpx(bmp.width, bmp.height); const r = await esporta(bmp, bmp.width, bmp.height); if (bmp.close) bmp.close(); return r; }
    const url = URL.createObjectURL(file);
    try {
      const img = await new Promise((ok, ko) => { const i = new Image(); i.onload = () => ok(i); i.onerror = () => ko(new Error(ERR_ANTEPRIMA)); i.src = url; });
      const w = img.naturalWidth || 1024, h = img.naturalHeight || 1024;
      controllaMpx(w, h);
      return await esporta(img, w, h);
    } finally { URL.revokeObjectURL(url); }
  }
  async function daPdf(file, maxPagine, avvisi) {
    let pdf, lib;
    try { lib = await import(CDN.pdfjs); lib.GlobalWorkerOptions.workerSrc = CDN.pdfWorker; } catch (e) { throw new Error(ERR_LIB); }
    try {
      pdf = await lib.getDocument({ data: new Uint8Array(await file.arrayBuffer()) }).promise;
    } catch (e) { if (!/^(PasswordException|InvalidPDFException|MissingPDFException|FormatError)$/.test(e && e.name)) throw new Error(ERR_LIB); throw new Error("PDF protetto o danneggiato: esporta una versione senza password o carica uno screenshot."); }
    if (pdf.numPages > maxPagine) avvisi.push("Mostrate solo le prime " + maxPagine + " pagine.");
    const out = [];
    try {
    for (let n = 1; n <= Math.min(pdf.numPages, maxPagine); n++) {
      const pag = await pdf.getPage(n), v1 = pag.getViewport({ scale: 1 });
      const vp = pag.getViewport({ scale: 1600 / Math.max(v1.width, v1.height) });
      const c = document.createElement("canvas"); c.width = Math.ceil(vp.width); c.height = Math.ceil(vp.height);
      const x = c.getContext("2d"); x.fillStyle = "#ffffff"; x.fillRect(0, 0, c.width, c.height);
      await pag.render({ canvasContext: x, viewport: vp }).promise;
      out.push(await esporta(c, c.width, c.height));
    }
    } finally { try { pdf.destroy(); } catch (e) {} }
    return out;
  }
  async function daPsd(file) {
    await carica(CDN.psd, ERR_LIB);
    const psd = root.agPsd.readPsd(await file.arrayBuffer(), { skipLayerImageData: true, skipThumbnail: true });
    if (!psd.canvas) throw new Error(ERR_ANTEPRIMA);
    controllaMpx(psd.canvas.width, psd.canvas.height);
    return esporta(psd.canvas, psd.canvas.width, psd.canvas.height);
  }
  async function daVideo(file) {
    const url = URL.createObjectURL(file), v = document.createElement("video");
    v.muted = true; v.playsInline = true; v.preload = "auto"; v.src = url;
    const tempo = setTimeout(() => { v.onloadedmetadata = v.onseeked = null; v.onerror && v.onerror(); }, 10000);
    try {
      await new Promise((ok, ko) => { v.onloadedmetadata = ok; v.onerror = () => ko(new Error(ERR_ANTEPRIMA)); });
      await new Promise((ok, ko) => { v.onseeked = ok; v.onerror = () => ko(new Error(ERR_ANTEPRIMA)); v.currentTime = Math.min(1, (v.duration || 2) / 2); });
      if (!v.videoWidth) throw new Error(ERR_ANTEPRIMA);
      controllaMpx(v.videoWidth, v.videoHeight);
      return await esporta(v, v.videoWidth, v.videoHeight);
    } finally { clearTimeout(tempo); v.removeAttribute("src"); URL.revokeObjectURL(url); }
  }
  D.converti = async function (file, maxPagine) {
    const err = D.controllaIngresso(file);
    if (err) throw new Error(err);
    maxPagine = maxPagine || 1;
    const avvisi = [], tipo = D.tipoSorgente(file);
    if (tipo === "sconosciuto") throw new Error(ERR_ANTEPRIMA);
    try {
      let pagine;
      if (tipo === "pdf") pagine = await daPdf(file, maxPagine, avvisi);
      else if (tipo === "psd") pagine = [await daPsd(file)];
      else if (tipo === "video") pagine = [await daVideo(file)];
      else pagine = [await daImmagine(file)];
      return { pagine, avvisi };
    } catch (e) {
      if (e && /^(PDF protetto|Immagine troppo grande|Non riesco|Libreria|Anteprima troppo pesante)/.test(e.message)) throw e;
      throw new Error(ERR_ANTEPRIMA);
    }
  };

  if (typeof module !== "undefined" && module.exports) module.exports = D;
  root.PBQrDisegno = D;
})(typeof window !== "undefined" ? window : globalThis);
